import React, { useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Objectives from "./components/Objectives";
import Products from "./components/Products";
import SubscriptionForm from "./components/SubscriptionForm";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import AdminPage from "./components/AdminPage";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="landing-page">
      <Header onScrollToForm={scrollToForm} />
      <Hero onScrollToForm={scrollToForm} />
      <section id="objetivos">
        <Objectives />
      </section>
      <section id="productos">
        <Products />
      </section>
      <section id="testimonios">
        <Testimonials />
      </section>
      <div ref={formRef}>
        <SubscriptionForm />
      </div>
      <section id="faq">
        <FAQ />
      </section>
      <FinalCTA onScrollToForm={scrollToForm} />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
